import { useEvent as o } from "../events.js";

function e(e, u) {
  o(e, "mousemove", u.onMouseMove), o(e, "mouseover", u.onMouseOver), o(e, "mouseout", u.onMouseOut), o(e, "mousedown", u.onMouseDown), o(e, "mouseup", u.onMouseUp);
}

export default e;